import Button from './Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import {
    setShowLoadingModal,
    selectLoadingFinished,
    setLoadingFinished,
    setShowDownloadModal,
    setShowConfigLoadingModal,
} from '../features/products/productsSlice';
import Translator from './Translator';

export default function LoadingModal({ action }) {
    const dispatch = useDispatch();
    // const isLoadingFinished = true;
    const isLoadingFinished = useSelector(selectLoadingFinished);
    const [closeDownloadModal, setCloseDownloadModal] = useState(false);

    setTimeout(function () {
        setCloseDownloadModal(true);
    }, 40000);

    return (
        <div className="fixed inset-0 z-40 flex flex-wrap justify-center content-center">
            <div className="py-7 px-10 z-50 relative shadow-line-number w-[580px] bg-white text-black">
                {isLoadingFinished === true && action === 'formSend' && (
                    <FontAwesomeIcon className="cursor-pointer text-22 absolute right-3 top-2" icon={['fal', 'times']} onClick={() => closeLoadingModal()} />
                )}
                {closeDownloadModal && action === 'downloads' && (
                    <FontAwesomeIcon className="cursor-pointer text-22 absolute right-3 top-2" icon={['fal', 'times']} onClick={() => closeLoadingModal()} />
                )}
                <div className="flex flex-col mx-auto">
                    <div className="font-medium text-22">
                        {action === 'formSend' && isLoadingFinished !== true && <Translator id="popup.request.message.sent.progress"></Translator>}
                        {action === 'formSend' && isLoadingFinished === true && <Translator id="popup.request.message.sent.finished"></Translator>}
                        {action === 'downloads' && isLoadingFinished === true && <Translator id="popup.download.configuration.generated"></Translator>}
                        {action === 'configLoad' && (
                            <p>
                                <Translator id="popup.load.configuration.main" />
                                <br />
                                <Translator id="popup.load.configuration.wait" />
                            </p>
                        )}
                        {action === 'downloads' && isLoadingFinished !== true && (
                            <p>
                                <Translator id="popup.load.download.main" />
                                <br />
                                <Translator id="popup.load.download.wait" />
                            </p>
                        )}
                    </div>

                    {action === 'formSend' && (
                        <>
                            {isLoadingFinished !== true && (
                                <div className="w-full mt-6 flex justify-center">
                                    <div className="lds-facebook w-full">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}

                    {action !== 'formSend' && isLoadingFinished !== true && (
                        <div className="w-full mt-6 flex justify-center">
                            <div className="lds-facebook w-full">
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="text-right pt-6">
                    {((isLoadingFinished && action === 'formSend') || closeDownloadModal) && (
                        <Button
                            className={
                                'text-20 bg-black text-white border inline-block py-2 px-9 cursor-pointer transition-all duration-300 hover:brightness-75 border-black'
                            }
                            onClick={() => closeLoadingModal()}
                        >
                            <Translator id="popup.action.button.close"></Translator>
                        </Button>
                    )}
                </div>
            </div>
            {((isLoadingFinished !== true && action === 'formSend') || !closeDownloadModal) && (
                <div className="popup z-30 fixed inset-0 flex-wrap justify-center bg-black bg-opacity-50" id="popup-darken" />
            )}
            {((isLoadingFinished === true && action === 'formSend') || closeDownloadModal) && (
                <div
                    className="popup z-40 fixed inset-0 flex-wrap justify-center bg-black bg-opacity-50"
                    id="popup-darken"
                    onClick={() => closeLoadingModal()}
                />
            )}
        </div>
    );

    function closeLoadingModal() {
        dispatch(setShowLoadingModal(false));
        dispatch(setLoadingFinished(false));
        dispatch(setShowDownloadModal(false));
        dispatch(setShowConfigLoadingModal(false));
    }
}
